import React, { useEffect } from "react";
import { PageHeader } from "./PageHeader";
import { DataBox } from "./DataBox";
import { DetailDrawer } from "./DetailDrawer";
import { useMarketingListModel } from "../allMemberMarketingListModel";

export function AllMemberMarketingList() {
    const {
        loadData,
        resetState,
    } = useMarketingListModel()
    useEffect(() => {
        loadData({ pageNum: 1 }, {}).then()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [resetState])
    return (
        <>
            <PageHeader />
            <DataBox />
            <DetailDrawer />
        </>
    );
}

